var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
    _vm.$options.$styles.item,
    _vm.data.class,
    _vm.data.staticClass,
    {
      'opacity-100': _vm.props.loaded,
    } ],attrs:{"data-test":_vm.props.dataTest || null}},[_c('div',{class:{
      ' flex-0 ': _vm.props.collapsePrimary,
      ' flex-1 ': !_vm.props.collapsePrimary,
    }},[(_vm.$slots.before)?_c('div',{class:_vm.$options.$styles.beforeSlot},[_vm._t("before")],2):_vm._e(),_c('div',{class:_vm.$options.$styles.defaultSlot},[_vm._t("default")],2),(_vm.$slots.tertiary)?_c('div',{class:_vm.$options.$styles.tertiarySlot},[_vm._t("tertiary")],2):_vm._e()]),_vm._t("secondary"),(_vm.$slots.after)?_c('div',{class:_vm.$options.$styles.afterSlot},[_vm._t("after")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }